import React from "react";
import { Button } from "components/ui/Button";
import { DownloadIcon, MailIcon, MoreVerticalIcon } from "components/icons/Icons";
import { Menu, MenuItems, MenuItem, MenuButton } from "@headlessui/react";
import { downloadDocumentByStoredId } from "services/documentsAPI";
import { SimulationDocumentDto } from "api/documents";
import { useSendDevisDialog } from "./send-devis/useSendDevisDialog";

type DocumentCardTooltipProps = {
  simulationDoc: SimulationDocumentDto
};

export const DocumentCardTooltip: React.FC<DocumentCardTooltipProps> = ({ simulationDoc }) => {

  const { openSendDevisDialog } = useSendDevisDialog({
    emailTo: ['TODO'],
    docsToSend: [simulationDoc]
  });

  const downloadCurrentDoc = async () => {
    const temp = await downloadDocumentByStoredId(simulationDoc.storedFileId!);
    const blob = new Blob([temp], { type: "pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${simulationDoc.fileName}.pdf`.toLocaleLowerCase(); // Remplacez par le nom souhaité du fichier

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  return (
    <Menu>
      <MenuButton as={Button} color="slate" round>
        <MoreVerticalIcon />
      </MenuButton>
      <MenuItems
        transition
        anchor="left"
        className="z-10 -ml-2 w-52 origin-top-right rounded-xl border bg-white p-1 text-sm/6 text-black transition duration-100 ease-out [--anchor-gap:--spacing(1)] focus:outline-none data-closed:scale-95 data-closed:opacity-0"
      >
        <MenuItem>
          <button onClick={downloadCurrentDoc} className="group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 data-focus:bg-black/10">
            <DownloadIcon className="size-4 fill-white/30" />
            Télécharger
            <kbd className="ml-auto hidden font-sans text-xs text-white/50 group-data-focus:inline">⌘D</kbd>
          </button>
        </MenuItem>
        {/* <MenuItem> */}
        {/*   <button onClick={openSendDevisDialog} className="group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 data-focus:bg-black/10"> */}
        {/*     <MailIcon className="size-4 fill-white/30" /> */}
        {/*     Envoyer le document */}
        {/*     <kbd className="ml-auto hidden font-sans text-xs text-white/50 group-data-focus:inline">⌘D</kbd> */}
        {/*   </button> */}
        {/* </MenuItem> */}
      </MenuItems>
    </Menu>
  );
};
